import { Base64 } from 'js-base64';

export function encodeBase64(obj: Object) {
  return Base64.encode(JSON.stringify(obj));
}

export function decodeBase64(string: string) {
  return Base64.decode(string);
}
